import { createContext, useCallback, useState, useSyncExternalStore } from "react"
import API from "services/api"
import _ from "lodash"
import toast from "react-hot-toast"

export const CPatentContext = createContext({})

const CPatentProvider = (props) => {
	const [contactPatents, setContactPatents] = useState([])
	const [cpatentbyPage, setCPatentByPage] = useState([])
	const [detailCPatent, setDetailCpatent] = useState({})
	const [error, setIsError] = useState(null)
	const [searchContact, setSearchContact] = useState("")
	const [filterContact, setFilterContact] = useState("")
	const [dataFilterDropdown, setDataFilterDropdown] = useState(null)

	const [detailContact, setDetailContact] = useState(null)

	const [openEdit, setOpenEdit] = useState(false)
	// open chnge contact
	const [open, setOpen] = useState(false)
	const [openChange, setOpenChange] = useState(false)
	const [selected, setSelected] = useState(null)

	// Contacts
	const getListCpantent = useCallback(async (params) => {
		await API.getListCpantent(params)
			.then((res) => {
				const { data } = res
				setContactPatents(data)
			})
			.catch((err) => {
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const getCpatentbyPage = (params) => {
		API.getCpatentbyPage(params)
			.then((res) => {
				const { data } = res
				setCPatentByPage(data)
			})
			.catch((err) => {
				setIsError(err.message || "An error occurred")
			})
	}

	const getCPatent = useCallback(async (id, params) => {
		return await API.getCPatent(id, params)
			.then((res) => {
				const { data } = res

				setDetailCpatent(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const putCpatent = useCallback(async (id, body) => {
		return API.putCpatent(id, body)
			.then((res) => {
				const { data } = res

				setDetailCpatent(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const handleSearchContact = async (e) => {
		if (e) {
			if (dataFilterDropdown !== null) {
				const searchQuery = e?.target?.value.toString().toLowerCase()
				setSearchContact(searchQuery)
				const filtered = ["companyName", "contactPerson", "name", "phone", "fax", "email", "category", "address"].map((x, i) => {
					return dataFilterDropdown.filter((el) => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1
						}
						return false
					})
				})
				const dataset = _.maxBy(filtered, function (o) {
					return o.length
				})
				setFilterContact(dataset)
			} else {
				const searchQuery = e?.target?.value.toString().toLowerCase()
				setSearchContact(searchQuery)
				const filtered = ["companyName", "contactPerson", "name", "phone", "fax", "email", "category", "address"].map((x, i) => {
					return contactPatents.filter((el) => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1
						}
						return false
					})
				})
				const dataset = _.maxBy(filtered, function (o) {
					return o.length
				})
				setFilterContact(dataset)
			}
		} else {
			setSearchContact("")
			setFilterContact(contactPatents)
		}
	}

	return (
		<CPatentContext.Provider
			value={{
				error,
				setIsError,

				contactPatents,
				cpatentbyPage,
				detailCPatent,

				setContactPatents,
				setCPatentByPage,
				setDetailCpatent,

				getListCpantent,
				getCpatentbyPage,
				getCPatent,

				searchContact,
				filterContact,
				dataFilterDropdown,
				handleSearchContact,

				openEdit,
				setOpenEdit,
				selected,
				setSelected,

				putCpatent,

				open,
				setOpen,

				detailContact,
				setDetailContact
			}}
			{...props}
		/>
	)
}

export default CPatentProvider
